import CustomToast, { addWarningToast } from "@/components/custom-toast/custom-toast";
import { ModalProvider } from "@/components/modal-popup/modal-popup";
import { tokenStorage } from "@/data/secure-storage";
import { InitializationStateComponent } from "@/init/initialization-state-component";
import { clearPasswordChangeCookies, clearUserRoleCookie } from "@/utils/cookie-utils";
import { LOGIN_PATH } from "@/utils/global-constants";
import { useI18n } from "@/utils/i18n";
import {
  SESSION_AUTH_ERROR_EVENT,
  SessionAuthErrorEventDetail,
} from "@/utils/session-auth-error";
import { useEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export default function RootLayout() {
  const { locale } = useI18n();

  return (
    <div className="root-container">
      <InitializationStateComponent>
        <ModalProvider>
          <SessionAuthErrorHandler />
          {/* 언어를 바꾸면 화면 문자열을 한 번에 다시 그리도록 라우트 트리를 재마운트한다. */}
          <Outlet key={locale} />
          <CustomToast />
        </ModalProvider>
      </InitializationStateComponent>
    </div>
  );
}

function SessionAuthErrorHandler() {
  const navigate = useNavigate();
  const isHandlingAuthErrorRef = useRef(false);

  useEffect(() => {
    const clearLocalAuthState = async () => {
      clearUserRoleCookie();
      clearPasswordChangeCookies();
      await tokenStorage.clearTokens();
      await tokenStorage.clearAesKey();
    };

    const handleSessionAuthError = (event: Event) => {
      if (isHandlingAuthErrorRef.current) return;

      const detail = (event as CustomEvent<SessionAuthErrorEventDetail>).detail;
      if (!detail) return;

      isHandlingAuthErrorRef.current = true;
      addWarningToast([detail.title, ...detail.description].join("\n"));
      void clearLocalAuthState().finally(() => {
        navigate(detail.redirectPath || LOGIN_PATH, { replace: true });
        window.setTimeout(() => {
          isHandlingAuthErrorRef.current = false;
        }, 3000);
      });
    };

    window.addEventListener(SESSION_AUTH_ERROR_EVENT, handleSessionAuthError);
    return () => {
      window.removeEventListener(SESSION_AUTH_ERROR_EVENT, handleSessionAuthError);
    };
  }, [navigate]);

  return null;
}
